import {
  applySnapshot,
  Instance,
  SnapshotIn,
  SnapshotOut,
  getParent,
  getRoot,
  flow,
  types,
} from 'mobx-state-tree';
import { debug, request, utils } from 'lib';

const initState = {};

export const multiPkPropTypes = ['nlt', 'nlyl', 'ywd', 'wxkj'];

const PropModel = types.model('PropModel', {
  total: 0,
  remain: 0,
});

const PropsModel = types.model('PropsModel', {
  // 能量糖
  nlt: types.optional(PropModel, {}),
  // 能量饮料
  nlyl: types.optional(PropModel, {}),
  // 烟雾弹
  ywd: types.optional(PropModel, {}),
  // 无懈可击
  wxkj: types.optional(PropModel, {}),
  //
  bonus: 0,
});

export const MultiPkInfoModel = types
  .model('MultiPkInfoModel', {
    room_id: 0,
    // 1-胜利 2-失败 3-平局 默认为0
    pk_result: 0,
    pk_value: 0,
    nickname: '',
    pic: '',
    props: types.optional(PropsModel, {}),
  })
  .views((self) => {
    return {
      get hasYwd() {
        return self.props.ywd.remain > 0;
      },
    };
  });

const ModeInfoModel = types
  .model('ModeInfoModel', {
    // 1PK准备中, 2PK进行中 ，3PK结束，4真正结束
    stage: 0,
    stage_desc: '',
    // 当前阶段持续时间
    duration: 0,
    // 当前阶段剩余时间
    remain_time: 0,
    multi_pk_info: types.array(MultiPkInfoModel),
  })
  .views((self) => {
    return {
      get currentRoomInfo() {
        const { roomId } = getRoot(self).room;
        return self.multi_pk_info.find((item) => {
          return item.room_id === roomId;
        });
      },
      get otherRoomInfo() {
        const { roomId } = getRoot(self).room;
        return self.multi_pk_info.find((item) => {
          return item.room_id !== roomId;
        });
      },
      get totalValue() {
        return self.multi_pk_info.reduce((total, item) => {
          return total + item.pk_value;
        }, 0);
      },
      get isShowResult() {
        return self.stage === 3;
      },
      get remainTimeText() {
        return utils.getTimerText(self.remain_time);
      },
    };
  })
  .actions((self) => {
    const decreaseRemainTime = () => {
      if (self.remain_time > 0) {
        self.remain_time--;
      }
      self.multi_pk_info.forEach((item) => {
        multiPkPropTypes.forEach((prop) => {
          if (item.props[prop].remain > 1) {
            item.props[prop].remain--;
          }
        });
      });
    };
    const getRoomPkInfo = (roomId) => {
      return self.multi_pk_info.find((item) => {
        return item.room_id === roomId;
      });
    };
    const updateTopUser = (roomId, topUsers) => {
      const pkInfo = getRoomPkInfo(roomId);
      if (pkInfo) {
        pkInfo.top_user = topUsers;
      }
    };
    const updatePkValue = (isSelf, value) => {
      if (isSelf) {
        self.currentRoomInfo.pk_value = value;
      } else {
        self.otherRoomInfo.pk_value = value;
      }
    };
    return {
      decreaseRemainTime,
      getRoomPkInfo,
      updateTopUser,
      updatePkValue,
    };
  });

const MaskPkInfoModel = types
  .model('MaskPkInfoModel', {
    // 连麦时长
    pk_duration: 0,
    // 不为空代表匹配中
    matching: types.optional(
      types.model({
        id: '',
        timestamp: 0,
      }),
      {},
    ),
    // 不为空代表斩杀时刻
    crit_info: types.optional(
      types.model({
        duration: -1,
      }),
      {},
    ),
    mode_info: types.optional(ModeInfoModel, {}),
  })
  .views((self) => {
    return {
      get isInMaskPk() {
        return self.matching || self.mode_info.stage;
      },
      get isPk() {
        return self.mode_info.stage > 0;
      },
      get isMatching() {
        return self.matching.id && !self.mode_info.stage;
      },
      // 是否是斩杀时刻
      get isCrit() {
        return self.crit_info.duration > -1 && self.mode_info.stage === 2;
      },
    };
  })
  .actions((self) => {
    return {
      decreaseCritDuration() {
        if (self.crit_info.duration > 0) {
          self.crit_info.duration--;
        }
      },
    };
  });

const Model = types
  .model('MaskModel', {
    info: types.optional(MaskPkInfoModel, {}),
  })
  .actions((self) => {
    const updateInfo = (info) => {
      self.info = info;
    };

    return {
      updateInfo,
    };
  });

export const currentRoomPropOrder = ['nlt', 'nlyl', 'ywd', 'wxkj'];
// eslint-disable-next-line import/no-mutable-exports
export const otherRoomPropOrder = ['nlt', 'nlyl', 'ywd', 'wxkj'];

export default {
  initState,
  Model,
};
